import React from 'react';
import { Box, Text } from '@chakra-ui/react';
export function WelcomePage() {
  return <Box px={10} py={8} data-id="element-417">
      <Text fontSize="2xl" fontWeight="bold" color="black" mb={3} data-id="element-418">
        Welcome
      </Text>
      <Text fontSize="lg" color="black" mb={6} data-id="element-419">
        This site is for viewing and updating Board and/or Committee members.
      </Text>

      <Text fontSize="2xl" fontWeight="bold" color="black" mb={3} data-id="element-420">
        Instructions:
      </Text>
      <Box as="ol" pl={6} color="black" fontSize="lg" style={{
      listStyleType: 'decimal'
    }} data-id="element-421">

        <Box as="li" mb={2} data-id="element-422">
          Use the menu on the left to select either Boards or Committees.
        </Box>
        <Box as="li" mb={2} data-id="element-423">
          Select the board or committee from the dropdown list.
        </Box>
        <Box as="li" mb={2} data-id="element-424">
          Click on the board or committee to move to the edit screen.
        </Box>
        <Box as="li" mb={2} data-id="element-425">
          You can download a report showing all the current Board and Committee
          members, including your current or recent changes.
        </Box>
      </Box>
    </Box>;
}